import { render, staticRenderFns } from "./DocsDialog.vue?vue&type=template&id=3a628f6c&"
import script from "./DocsDialog.vue?vue&type=script&lang=ts&"
export * from "./DocsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports